import { useMutation, useQueryClient } from 'react-query';
import { useAPI } from 'services/axios';

import { Endpoints, queryKeys } from '../constants';

const putChangePasswordApi = (payload: any) => {
  const { id, data } = payload;
  return useAPI({
    method: 'PATCH',
    url: `${Endpoints.CHANGE_PASSWORD}`,
    data,
  });
};

export const useChangePasswordApiQuery = () => {
  const queryClient = useQueryClient();
  return useMutation(putChangePasswordApi, {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.CHANGE_PASSWORD]);
    },
  });
};
